import React from "react";
import "./CompanyInsights.scss"; // Import the SCSS file

const CompanyInsights = () => {
  return (
    <div className="finance-companyInsights">
      <div className="finance-header">
        <div className="finance-headerInsights">INSIGHTS</div>
        <h2>Company Insights</h2>
        <div className="finance-headerContent">
          <p>
            <span class="material-symbols-outlined">check</span> <p>Empowering Your Team with Training</p>
            
          </p>
          <p>
            <span class="material-symbols-outlined">check</span> Performance
            Proven Strategies
          </p>
        </div>
      </div>

      <div className="finance-stats">
        <div className="finance-statItem">
          <div className="finance-icon"><img src="../assets/img/finance/finance-insights-img1.png" alt="" /></div>
          <p className="finance-statCount">150+</p>
          <p className="finance-statLabel">Team member</p>
        </div>

        <div className="finance-statItem">
          <div className="finance-icon"><img src="../assets/img/finance/finance-insights-img2.png" alt="" /></div>
          <p className="finance-statCount">17k+</p>
          <p className="finance-statLabel">Complete project</p>
        </div>

        <div className="finance-statItem">
          <div className="finance-icon"><img src="../assets/img/finance/finance-insights-img3.png" alt="" /></div>
          <p className="finance-statCount">15+</p>
          <p className="finance-statLabel">Winning award</p>
        </div>
      </div>
    </div>
  );
};

export default CompanyInsights;
